'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: green;\n'], ['\n  color: green;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tooltip = require('../tooltip/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // TODO: Buy It Now functionality

var Button = _styledComponents2.default.button(_templateObject);

/** @class BuyItNowButton
  * A button to manage purchasing products
  * from thier vendors
  * @param {string} productID - The product to sell.
  */

var BuyItNowButton = function (_Component) {
  _inherits(BuyItNowButton, _Component);

  /** @constructor
    * Creates a new instance of BuyItNowButton
    * for the specified product.
    */
  function BuyItNowButton(props) {
    _classCallCheck(this, BuyItNowButton);

    var _this = _possibleConstructorReturn(this, (BuyItNowButton.__proto__ || Object.getPrototypeOf(BuyItNowButton)).call(this, props));

    _this.state = {};
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /** @method handleClick
    * Event handler.
    */


  _createClass(BuyItNowButton, [{
    key: 'handleClick',
    value: function handleClick() {
      window.vexpo.buyItNow(this.props.productID);
    }
    /** @method render
      * Renders the BuyItNowButton.
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _tooltip2.default,
        { text: 'Buy It Now' },
        _react2.default.createElement(
          Button,
          { onClick: this.handleClick },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'shopping-cart', size: '2x' })
        )
      );
    }
  }]);

  return BuyItNowButton;
}(_react.Component);

exports.default = BuyItNowButton;


BuyItNowButton.propTypes = {
  productID: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/buy-it-now-button.js
// module id = 1329
// module chunks = 0